"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Dribbble;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Dribbble(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Dribbble"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "dribbble",
    className: "cls-1",
    d: "M50,10A40,40,0,1,0,90,50,40.045,40.045,0,0,0,50,10ZM76.447,28.446a34.006,34.006,0,0,1,7.715,21.283,79.85,79.85,0,0,0-23.791-1.1c-.927-2.265-1.8-4.257-3-6.712C70,36.76,75.726,29.42,76.447,28.446Zm-3.8-3.951c-.615.875-5.758,7.788-17.907,12.342a182.368,182.368,0,0,0-12.748-20A34.077,34.077,0,0,1,72.649,24.5ZM35.474,19.132a218.149,218.149,0,0,1,12.668,19.76,127.458,127.458,0,0,1-31.587,4.163A34.294,34.294,0,0,1,35.474,19.132Zm-19.64,30.92c0-.349.007-.7.017-1.044a126.023,126.023,0,0,0,35.114-4.862c.978,1.914,1.913,3.857,2.77,5.8C41.38,53.424,30.155,63.416,24.617,72.9A34.03,34.03,0,0,1,15.834,50.052Zm13.2,26.954c3.568-7.3,13.254-16.713,27.028-21.412A142,142,0,0,1,63.346,81.5,34.1,34.1,0,0,1,29.029,77.006ZM69.09,78.375a147.454,147.454,0,0,0-6.638-24.36,50.147,50.147,0,0,1,21.282,1.46A34.225,34.225,0,0,1,69.09,78.375Z"
  })));
}